import {DashboardLinksDiv} from './styled'

import React from 'react'


export interface DashboardLinksProps {
    text: string
    url: string
}

export interface DashBoardLinkPropMain {
    links: Array<DashboardLinksProps>
}

export const DashboardLinks: React.FC<DashBoardLinkPropMain> = ({
    links,
    ...props
}) => {
    const linksList = links && links.map((link, index) => (
        <li key={index}><a href={link.url}>{link.text}</a></li>
    ))
    return (
        <DashboardLinksDiv>
            {linksList}
        </DashboardLinksDiv>
    )
}
